module.exports = "/_next/static/images/010efa9c71928eff2d827592f31d7a64-dress-code-2.png.webp";